module.exports = __webpack_public_path__ + "img/pcrown_yellow.e0488785.png";